module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Light.e6dc7e59.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Light.ttf
// module id = 514
// module chunks = 0